// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"100":"c908fee3","540":"2848f3aa","594":"2848f3aa","647":"2848f3aa"}[chunkId] + ".chunk.css";
};